import { Outlet } from "react-router-dom";

const Layout = () => {
  return (
    <div className="h-screen bg-gray-50">
      <Outlet />
    </div>
  );
};

export default Layout;
